import { ITypeOption } from "@/components/excel/schema/definiens/bizType";
import {
  IProviderOption,
  Provider,
} from "@/components/excel/schema/definiens/provider";
import { ISelectorChooser } from "@/components/excel/schema/definiens/selector";
import { findSelectorOption } from "@/components/excel/schema/selector";

function getOptionText(value: number, chooser?: ISelectorChooser) {
  const obj = findSelectorOption(value, chooser);
  return obj?.text ?? `${value}`;
}
function commonProvider(
  option: IProviderOption,
  chooser?: ISelectorChooser
): string[] {
  const names: string[] = [];
  option.value.forEach((item: number | number[]) => {
    if (Array.isArray(item)) {
      if (option.showPrefix) {
        const name = item
          .map((it) => getOptionText(it, chooser))
          .join(option.separator);
        names.push(name);
      } else {
        names.push(getOptionText(item[item.length - 1], chooser));
      }
    } else {
      names.push(getOptionText(item, chooser));
    }
  });
  return names;
}
export function buildCommonProvider(
  option: ITypeOption
): { [key: number]: Provider } {
  return {
    [option.value]: function (providerOption: IProviderOption): string[] {
      return commonProvider(providerOption, option.selector);
    },
  };
}
